import Vue from 'vue'
import Router from 'vue-router'
import prior from '@/views/prior'
import wxprior from '@/views/wxprior'
import appPrior from '@/views/appPrior'
import download from '@/views/download'
import issue from '@/views/issue'
import help from '@/views/help'
import editor from '@/views/editor'
import share from '@/views/share'
import shareUser from '@/views/shareUser'
import store from '@/vuex/store'
import instruction from '@/views/instruction'
import product_show from '@/views/product_show'

Vue.use(Router)
const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/product_show',
			name: 'product_show',
			component: product_show
		},
		{
			path: '/prior/:share_user_id?',
			name: 'prior',
			component: prior
		},
		{
			path: '/wxprior/:share_user_id?',
			name: 'wxprior',
			component: wxprior
		},
		{
			path: '/appPrior/:share_user_id?',
			name: 'appPrior',
			component: appPrior
		},
		{
			path: '/',
			name: 'download',
			component: download
		},
		{
			path: '/download',
			name: 'download',
			component: download
		},
		{
			path: '/help/:fnsn?',
			name: 'help',
			component: help
		},
		{
			path: '/issue/:fnsn?',
			name: 'issue',
			component: issue
		},
		{
			path: '/editor/:editorValue?',
			name: 'editor',
			component: editor
		},
		{
			path: '/instruction/:user_id?/:dev_id?',
			name: 'instruction',
			component: instruction
		},
		{
			path: '/share/:sharedata?',
			name: 'share',
			component: share
		},
		{
			path: '/shareUser',
			name: 'shareUser',
			component: shareUser
		},
		{
			path: '/go/:a?/:b?/:c?/:d?/:e?',
			name: 'go',
		},
		
	]
})
//路由完成前
router.beforeEach((to, from, next) => {
	let iswx=navigator.userAgent.toLowerCase().match(/MicroMessenger/i)=="micromessenger"
	//验证去#，兼容不去#
	if(window.location.hash.length>0){
		window.location=window.location.protocol+'//'+window.location.host+window.location.hash.substring(1)
	}
	//微信openid存在判断
	if(to.name!='go' && iswx && (!localStorage.openid || localStorage.openid=="undefined")){
		window.location=`https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxcfe30cbc79aa23cc&redirect_uri=${window.location.protocol}//${window.location.host}/go&response_type=code&scope=snsapi_base&state=${window.location.pathname}#wechat_redirect`
	}
	//微信返回openid跳转
	if(to.name=='go' && to.query.code){
		localStorage.clear()
		store.dispatch('post',{u:'/wx/grant_type',d:{code:to.query.code}}).then(function(res){
	    	localStorage.openid=res.data.openid
	    	let go=to.query.state?to.query.state:''
			window.location=window.location.protocol+'//'+window.location.host+go
		})
	}
	//微信js配置获取
	store.dispatch('post',{u:'/wx/wxargs',d:{wxurl:window.location.protocol+'//'+window.location.host+to.fullPath}}).then(function(res){
    	wx.config({
			debug: false,
			appId:res.data.app_id,
			timestamp:res.data.timestamp,
			nonceStr:res.data.nonceStr,
			signature:res.data.signature,
			jsApiList: ['updateAppMessageShareData','updateTimelineShareData','onMenuShareAppMessage','onMenuShareTimeline']
		});
		wx.error(function(res){
			console.log(res)
		});
	})
	next()
});
//路由完成后
router.afterEach((to) => {
	
});
export default router


// WEBPACK FOOTER //
// ./src/router/index.js